export default "__VITE_ASSET__ClC6$rzz__"